import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';

import { CedulaIdentidadeService } from '@/core/api/sicom-api/servicos/pessoa-fisica/cedula-identidade/cedula-identidade.service';
import { ServicoAnexoService } from '@/core/api/sicom-api/servicos/shared/servico-anexo.service';
import type { CedulaIdentidadeRequest, CedulaIdentidadeResponse } from '@/core/api/sicom-api/servicos/pessoa-fisica/cedula-identidade/cedula-identidade.model';

@Injectable({ providedIn: 'root' })
export class CedulaIdentidadeServicosService {
    constructor(
        private api: CedulaIdentidadeService,
        private servicoAnexo: ServicoAnexoService
    ) {}

    consultar(params: CedulaIdentidadeRequest, context?: HttpContext): Observable<CedulaIdentidadeResponse> {
        if (!params?.numeroProtocolo || !params?.anoProtocolo || !params?.ufCrm) {
            return throwError(() => new Error('Parâmetros inválidos: numeroProtocolo, anoProtocolo e ufCrm são obrigatórios.'));
        }

        return this.api.consultar(params, context);
    }

    visualizarAnexo(idAnexo: string, context?: HttpContext): Observable<Blob> {
        const id = idAnexo?.trim();
        if (!id) {
            return throwError(() => new Error('Id do anexo não informado.'));
        }

        return this.servicoAnexo.visualizarAnexo(id, context);
    }
}
